<script>
	import { fade, draw, fly } from 'svelte/transition';
	import { onMount } from 'svelte';

	export let vcard;
	let noti = false;	
	const copiar = () =>{
		let url = window.location.href;
		console.log(url);
		navigator.clipboard.writeText(url)
		.then(() => {
			noti = true
			setTimeout(function(){
				noti = false
			}, 4000)
		})
		.catch(err => {
			console.log('Something went wrong', err);
		})
	}
</script>
<div class="compartir">
	<div class="link">
		<span>Add to <br>Contacts</span>
		<a class="vcard" href="../images/vcard/{vcard.file}" target="_blank" download>
			<img src="../images/contact.svg" alt="">
		</a>
	</div>
	<div class="link">
		<span>Copy<br>Link</span>	
		<button class="shared" on:click={copiar}>
			<img src="../images/shared.svg" alt="">
		</button>
	</div>
</div>

{#if noti}
<div class="notificacion " transition:fly="{{ x: 200, duration: 600 }}">
	The URL was copied
</div> 
{/if}

<style lang="scss">
.notificacion{
	background: var(--blue);
	color: var(--white);
	padding: 15px 25px;
	position: fixed;
	bottom: 15px;
	right: 15px;
}
.compartir{
	position: absolute;
	right: 10px;
	bottom: 10px;
	.link{
		display: flex;
		justify-content: end;
		align-items: center;
		span{
			text-align: right;
			margin-right: 10px;
		}
	}
	a,
	button{
		cursor: pointer;
		border: none;
		width: 50px;
		height: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 100%;
		margin-bottom: 10px;
		box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.5);
		padding: 0px;
		&.vcard{
			background: var(--blue);
		}
		&.shared{
			background: var(--blue-dark);
		}
	}
}
</style>